import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Avatar.theme = Avatar.theme || {};

Avatar.theme.Tabs = function TabsFn() {
  var selectors = {
    tabLink: '[data-toggle="tab"]',
    tabPane: '.tab-pane'
  };
  var classes = {
    active: 'active'
  };

  function Tabs(tabs) {
    this.container = tabs;

    this._cacheSelectors();

    this._setupListeners();
  }

  Tabs.prototype = _objectSpread(_objectSpread({}, Tabs.prototype), {}, {
    _cacheSelectors: function _cacheSelectors() {
      this.cache = {
        tabLinks: this.container.querySelectorAll(selectors.tabLink),
        tabPanes: this.container.querySelectorAll(selectors.tabPane)
      };
    },
    _setupListeners: function _setupListeners() {
      var _this = this;

      this.eventHandlers = this._setupEventHandlers();
      this.cache.tabLinks.forEach(function (tabLink) {
        tabLink.addEventListener('click', _this.eventHandlers.handleTabLinkClick);
      });
    },
    _setupEventHandlers: function _setupEventHandlers() {
      return {
        handleTabLinkClick: this._handleTabLinkClick.bind(this)
      };
    },
    _handleTabLinkClick: function _handleTabLinkClick(evt) {
      evt.preventDefault();
      var currentTarget = evt.currentTarget;
      var tabIndex = currentTarget.dataset.tabIndex; // Remove from all

      this.cache.tabLinks.forEach(function (tabLink) {
        return tabLink.classList.remove(classes.active);
      });
      this.cache.tabLinks.forEach(function (tabLink) {
        return tabLink.setAttribute('aria-selected', false);
      });
      this.cache.tabPanes.forEach(function (tabLink) {
        return tabLink.classList.remove(classes.active);
      }); // Add to one

      currentTarget.classList.add(classes.active);
      currentTarget.setAttribute('aria-selected', true);
      this.cache.tabPanes[tabIndex].classList.add(classes.active);
    },
    destroy: function destroy() {
      var _this2 = this;

      this.cache.tabLinks.forEach(function (tabLink) {
        tabLink.removeEventListener('click', _this2.eventHandlers.handleTabLinkClick);
      });
    }
  });
  return Tabs;
}();